import { useContext } from 'react'
import { PostHogContext } from './PostHogProvider'

export function usePostHog() {
  return useContext(PostHogContext)
}
